 export async function post(url,json){
 
    const  response=await fetch(url,{
        method:"post",
        body:JSON.stringify(json),
       
        headers:{
            "Content-Type":"application/json",
        }
    });
    const restData=response.json();
     
    if(response.status!=200){
        throw new Error("Falla al comunicarnos con el servidor")
    }
    return restData;
}

export async function postFormData(url, json) {
  const response = await fetch(url, {
    method: 'POST',
    body: json,
  });

  const restData = await response.json();

  if (!response.ok) {
    // Procesa los errores basados en el contenido del cuerpo de la respuesta
    const errorMessage = restData.non_field_errors 
      ? restData.non_field_errors.join(' ')
      : 'Error desconocido al comunicarnos con el servidor';

    throw new Error(errorMessage);
  }

  return restData;
}

export async function postFiles(url,json){
 
  const  response=await fetch(url,{
      method:"post",
      body:json,
  });
  const restData=response.json();
   
  if(response.status!=200){
      throw new Error("Falla al comunicarnos con el servidor")
  }
  return restData;
}

export async function postHeader(url,json,auto){
  //let enc= encryptData(json, "PruebasUTI2024#");
  //json ={data:enc};
  const  response=await fetch(url,{
      method:"post",
      body:JSON.stringify(json),
      headers:{
          "Content-Type":"application/json",
          "Authorization":auto
      }
  });
  const restData=  response.json();
   
  if(response.error){
      throw new Error("Falla al comunicarnos con el servidor")
  }
  return restData;
}



function encryptData(data, key) {
    const algorithm = 'aes-256-cbc';
    const iv = crypto.randomBytes(16); // Vector de inicialización aleatorio
  
    const cipher = crypto.createCipheriv(algorithm, key, iv);
    const encryptedData = Buffer.concat([iv, cipher.update(data), cipher.final()]);
  
    return encryptedData.toString('hex');
  }

function decryptData(encryptedData, key) {
    const algorithm = 'aes-256-cbc';
    const iv = encryptedData.slice(0, 16); // Extraer vector de inicialización
    const encryptedDataBuffer = Buffer.from(encryptedData.slice(16), 'hex');
  
    const decipher = crypto.createDecipheriv(algorithm, key, iv);
    const decryptedData = Buffer.concat([decipher.update(encryptedDataBuffer), decipher.final()]);
  
    return decryptedData.toString('utf8');
  }
class HttpApi {
    constructor(url, key) {
      this.url = url;
      this.key = key;
      this.ip='http://conectados.injupemp.gob.hn:8080/';//'http://172.20.7.10:8080';
    }
  
    async post(endpoint, data) {
      const encryptedData = encryptData(data, this.key);
      const response = await fetch(this.url + endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(encryptedData),
      });
      const decryptedResponse = await response.json();
      return decryptedResponse;
    }
  
    async get(endpoint) {
      const response = await fetch(this.url + endpoint);
      const encryptedData = await response.text();
      const decryptedData = decryptData(encryptedData, this.key);
      return JSON.parse(decryptedData);
    }
  
    async put(endpoint, data) {
      const encryptedData = encryptData(data, this.key);
      const response = await fetch(this.url + endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(encryptedData),
      });
      const decryptedResponse = await response.json();
      return decryptedResponse;
    }
  }